import { AiContestEnrollmentFeaturePage } from "../ui";

/** AI 智能大赛报名页路由入口。 */
export function AiContestEnrollmentPage() {
  return <AiContestEnrollmentFeaturePage />;
}
